/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetKpIsQuery } from '../../models/get-kp-is-query';
import { GetKpIsQueryResult } from '../../models/get-kp-is-query-result';

export interface ApiKpIsGetKpIsPost$Plain$Params {
      body?: GetKpIsQuery
}

export function apiKpIsGetKpIsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpIsGetKpIsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetKpIsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpIsGetKpIsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetKpIsQueryResult>;
    })
  );
}

apiKpIsGetKpIsPost$Plain.PATH = '/api/KPIs/GetKPIs';
